import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import {PubSubService} from "@Common/core/services";
import {Bel} from "../../../../common/services/bel/bel/bel.model";
import {
  InformationComplementaire
} from "../../../../common/services/information-complementaire/information-complementaire.model";
import {SubSink} from "@Common/core/utils/subsink";
import {
  InformationComplementaireService
} from "../../../../common/services/information-complementaire/information-complementaire.service";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-information-complementaire-field',
  templateUrl: './information-complementaire-field.component.html',
  styleUrls: ['./information-complementaire-field.component.scss']
})
export class InformationComplementaireFieldComponent implements OnInit {

  @Input() Instruction = {};
  @Input() label = '';
  @Input() Bel: Bel = <Bel>{};
  @Input() edition_mode = false;
  SubSink: SubSink = new SubSink();
  infosCompsForm: UntypedFormGroup;
  InformationComplementaire: InformationComplementaire = <InformationComplementaire>{};

  constructor(private formBuilder: UntypedFormBuilder,
              private snackSvc: SnackBarToastyService,
              private pubSubSvc: PubSubService,
              private infosCompsSvc: InformationComplementaireService) {
    this._initInfosCompsForm();
  }

  ngOnInit(): void {
    this._initInfosCompsForm();
  }

  private _initInfosCompsForm() {
    this.infosCompsForm = this.formBuilder.group({
      bel: [this.Bel.id, []],
      dir_cmp: [null, []],
      dua_instruction: [null,[]],
      informations_complementaires: [this.Instruction['info_complementaire'],[]],
    });
  }

  saveInfosComps(): void {
    this.InformationComplementaire = {
      id: this.Instruction['info_complementaire_id'],
      dir_cmp: this.Instruction['dir_cmp_id'],
      dua_instruction: this.Instruction['instruction_id'],
      bel: this.Bel.id,
      informations_complementaires: this.infosCompsForm.get('informations_complementaires').value,
    }
    this.pubSubSvc.publish('loading', true);
    this.SubSink.sink = this.infosCompsSvc.updateOrcreate(this.InformationComplementaire)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_data) => {
        this.InformationComplementaire = _data;
        this.infosCompsForm.markAsPristine();
        this.snackSvc.toasty('Enregistrée', `Votre information complémentaire a bien été enregistrée.`, typeToast.success);
    });
  }
}
